/* eslint-disable max-lines */
/* TODO: remove the above line and reduce the line count */

import { PJAX_MAIN_CONTAINER_SELECTOR } from './constants';
import { appendFileToModal } from './modalCarousel';
import { store } from './reactTreeMounting';
import i18n from 'FRONTEND/utils/i18n';

let refreshReports;

/** ****************************** */
/** ******** Cells render ******** */
/** ****************************** */

export const dTChainRenderers = (renderFunction) => {
  return function(data, type, row, meta) {
    const renderedData = renderers[renderFunction](data, type, row);
    return dTAddHref(renderedData, type, row, meta);
  };
};

const dTVariableEllipsis = (data, type, maxLength) => {
  /**
   * Truncate long string with more than maxLength characters.
   * https://datatables.net/blog/2016-02-26#Ellipsis-rendering-plug-in
   */
  const stringData = (data instanceof Array) ? data.join(', ') : data;
  if (!stringData) {
    return '';
  }

  const safeData = stringData ? sanitizeString(stringData) : stringData;
  const dataIsTooLong = type === 'display' && stringData && stringData.length > maxLength;

  return dataIsTooLong ? `<span title="${safeData}">${sanitizeString(stringData.substring(0, maxLength))}&#8230;</span>` : safeData;
};

const getLink = (links, type) => {
  const linkArray = $.grep(links, (n) => {
    return n.rel === type;
  });
  return linkArray.length ? linkArray[0] : null;
};

const sanitizeString = (string) => {
  return string
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll('\'', '&#39;');
};

export const dTAddHref = (data, type, row, meta) => {
  /**
   * Add on each row the link sent from the Webservices.
   */
  if (type !== 'display') {
    return data;
  }

  if (!row.links?.length) {
    return data;
  }

  // Only test for temporary draft on the first column.
  if (meta.col === 0) {
    if (row.consultation_id && row.is_draft && dTIsTemporaryDraft(row.consultation_id)) {
      row.render_links = false;
      return data;
    }
  } else if (row.render_links === false) {
    return data;
  }

  const selfLink = getLink(row.links, 'self');
  if (!selfLink) {
    return data;
  }

  // Fill the cell and make it clickable.
  if (!data) {
    data = '&nbsp;';
  }

  if (selfLink.type === 'file') {
    return `<a href="${selfLink.href}" download>${data}</a>`;
  } else {
    return `<a data-pjax href="${selfLink.href}">${data}</a>`;
  }
};

const dTAge = (data) => {
  if (!data) {
    return '';
  }

  const ageUnits = {
    day: i18n._('d'),
    month: i18n._('m'),
    year: i18n._('y'),
  };

  const json_data = JSON.parse(data);
  return data ? json_data.value + ageUnits[json_data.unit] : '';
};

const dTBoolToFile = (data, type) => {
  /**
   * Transform a boolean into the file icon.
   */
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }
  return data ? '<i class="far fa-file"></i>' : '';
};

const dTBoolToUnread = (data, type) => {
  /**
   * Transform a boolean into the unread icon.
   */
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }
  return data ? '<i class="fas fa-envelope red"></i>' : '';
};

const dTCaseNotesIcon = (data, type) => {
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }
  const classes = 'far fa-comment-alt consultation-reminder-open clickable highlight_hover';
  return data ? `<i class="${classes}" title="${sanitizeString(data.substring(0, 2000))}"></i>` : '';
};

const dTColorCode = (data, type) => {
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }
  return data ? `<div class="color-code color-code-val-${data} consultation-reminder-open clickable"></div>` : '';
};


const dTDeleteIcon = (data, type, row) => {
  if (type !== 'display') {
    return '';
  }
  const link = getLink(data, 'self');
  const title = i18n._('Delete');
  return `
    <a class="clickable patient-file-delete" data-delete-url="${link.href}" data-file-name="${row.name}" data-is-admin="${row.is_administrative}">
      <i class="fas fa-trash highlight_hover" title="${title}"></i>
    </a>
  `;
};

const dTDownloadIcon = (data, type) => {
  if (type !== 'display') {
    return '';
  }
  const link = getLink(data, 'self');
  const title = i18n._('Download');
  return `
    <a href="${link.href}" download>
      <i class="fas fa-download highlight_hover" title="${title}"></i>
    </a>
  `;
};

const dTDownloadPDFIcon = (data, type) => {
  if (type !== 'display') {
    return '';
  }
  const link = getLink(data, 'pdf');
  if (!link) {
    return '';
  }
  const title = i18n._('Download');
  return `<i class="fas fa-download highlight_hover link_in_link" title="${title}" data-href="${link.href}"></i>`;
};
$(document).on('click', '.link_in_link', function downloadLink(event) {
  // To manage the link (download pdf) in link (consultation page), we don't create the inside link, but simulate one
  // when the user clicks on the icon.
  event.preventDefault();
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = $(this).data('href');
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
});


const dTEllipsis15 = (data, type) => {
  /**
   * Truncate long string with more than 15 characters.
   */
  if (type !== 'display') {
    return data;
  }
  return dTVariableEllipsis(data, type, 15);
};

const dTEllipsis30 = (data, type) => {
  /**
   * Truncate long string with more than 30 characters.
   */
  if (type !== 'display') {
    return data;
  }
  return dTVariableEllipsis(data, type, 30);
};

const dTEllipsis100 = (data, type) => {
  /**
   * Truncate long string with more than 100 characters.
   */
  if (type !== 'display') {
    return data;
  }
  return dTVariableEllipsis(data, type, 100);
};

const dTExamsToIcons = (data, type) => {
  /**
   * Transform station exams list into icons. Used in datatables.
   */
  if (!data) {
    return '';
  }
  if (type !== 'display') {
    return data;
  }

  let icons = '';
  const exams = [
    'interview',
    'ecg',
    'spiro',
    'nibp',
    'heart_rate',
    'oximetry',
    'temperature',
    'glucose',
    'respiratory_rate',
    'photo',
    'video',
    'attachments',
  ];
  const style = 'style="width: 30px; margin-right:-8px;"';
  exams.forEach(exam => {
    if (data.includes(exam)) {
      // Force icons size using style instead of CSS class as DataTables needs to be able to calculate the
      // column width without CSS.
      const html = `<img ${style} class="exam-icons" src="/static/images/exams/${exam}.png" onerror="this.onerror=null; this.src='/static/images/exams/${exam}.svg';">`;
      icons = icons.concat(html);
    }
  });

  return icons;
};

const dTList = (data, type) => {
  /**
   * Transform an array into a comma-separated list.
   */
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }
  return data ? data.join(', ') : '';
};

const dTModalIcon = (data, type, row) => {
  if (type !== 'display') {
    return '';
  }

  const isImage = typeof data === 'string' && data.startsWith('image/');
  const isVideo = typeof data === 'string' && data.startsWith('video/');
  if (!isImage && !isVideo) {
    return '';
  }

  const linkArray = $.grep(row.links, (n) => {
    return n.rel === 'self';
  });
  const fileLink = linkArray.length ? linkArray[0] : null;
  appendFileToModal(row.file_id, fileLink.href, isVideo, row.name, null);

  const title = i18n._('Fullscreen');
  return `
    <a class="clickable file-gallery" data-file-id="${row.file_id}">
      <i class="fas fa-expand-arrows-alt highlight_hover" title="${title}"></i>
    </a>
  `;
};

const dTNewTabIcon = (data, type, row) => {
  if (type !== 'display') {
    return '';
  }

  const isImage = typeof data === 'string' && data.startsWith('image/');
  const isVideo = typeof data === 'string' && data.startsWith('video/');
  if (!isImage && !isVideo) {
    return '';
  }

  const link = getLink(row.links, 'self');
  const title = i18n._('Open in new tab');
  return `
    <a href="${link.href}" target="_blank" title="${title}">
      <i class="fas fa-external-link-alt highlight_hover"></i>
    </a>
  `;
};

const dTReminderAdd = (data, type, row) => {
  if (type !== 'display') {
    return '';
  }

  const element = $('<i>')
    .addClass('fas fa-plus-circle consultation-reminder-open text-primary clickable highlight_hover')
    .prop('title', i18n._('Edit'))
    .attr('data-color-code', row.color_code || '')
    .attr('data-notes', row.notes || '')
    .attr('data-is-testing', row.is_testing || false)
    .attr('data-reminder-at', row.reminder_at || '')
    .attr('data-reminder-url', getLink(row.links, 'reminder').href);
  return element.get(0).outerHTML;
};

const dTReminderIcon = (data, type, row) => {
  if (!data) {
    return '';
  }
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }

  const element = $('<i>')
    .addClass('far fa-clock consultation-reminder-open clickable highlight_hover');

  if (new Date(data) < new Date()) {
    element.addClass('red')
      .prop('title', `${i18n._('Reminder')}: ${row.reminder_at_formatted} (${i18n._('overdue')})`);
  } else {
    element.prop('title', `${i18n._('Reminder')}: ${row.reminder_at_formatted}`);
  }
  return element.get(0).outerHTML;
};

const dTReportFinished = (data, type) => {
  /**
   * Transform a boolean into the clock icon. Used in Reports datatable 'finished' column.
   */
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }

  // Set page to be refreshed automatically in 15s if report isn't finished.
  if (!data && !refreshReports) {
    refreshReports = setTimeout(() => {
      if ($('#reports-list').length) {
        $.pjax.reload(PJAX_MAIN_CONTAINER_SELECTOR);
      }
      refreshReports = null;
    }, 15000);
  }

  return data ? '' : '<i class="far fa-clock"></i>';
};

const dTSpecialistNotesIcon = (data, type) => {
  /**
   * Replace content by icon and put the whole note into the tooltip.
   * The note is not truncated: '.tooltip-inner' keeps it readable (line breaks, scroll past 60vh).
   */
  if (type !== 'display') {
    return data;
  }
  return data ? `<span data-toggle="tooltip" title="${sanitizeString(data)}"><i class="far fa-comment-alt"></i></span>` : '';
};

const dTStatus = (data, type) => {
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }
  return data ? `<span class="status-badge">${data}</span>` : '';
};

const dTUrgencyToColor = (data, type) => {
  /**
   * Display red circle if consultation is urgent and green circle otherwise.
   */
  // Order, search and type get the original data.
  if (type !== 'display') {
    return data;
  }

  const urgencyCircle = $('<div>');

  if (data === 'Urgent') {
    urgencyCircle.addClass('urgency-red');
    urgencyCircle.html('!');
  } else {
    urgencyCircle.addClass('urgency-green');
    urgencyCircle.html('');
  }

  return urgencyCircle.get(0).outerHTML;
};

/** ****************************** */
/** ******** Lines render ******** */
/** ****************************** */

/**
 * Restyle drafts of consultations that are being sent (sending in progress).
 */
const dTIsTemporaryDraft = (consultation_id) => {
  if (!store) {
    return false;
  }
  const consultationsInProgressList = Object.values(store.getState().upload.progressMap || {}).map(({ id }) => id);
  return consultationsInProgressList.includes(consultation_id);
};

const dTNewConsultation = (row, data) => {
  /**
   * Highlight new consultation.
   */
  if (window.consultationToHighlight && window.consultationToHighlight === data.id) {
    row.classList.add('info');
    window.consultationToHighlight = null;
  }
};

const dTTagOnProperty = (row, data, property, CSSClass) => {
  /**
   * Apply CSS class to items that don't have the property defined as parameter.
   */
  const hasProperty = Object.prototype.hasOwnProperty.call(data, property);
  if (hasProperty && data[property]) {
    row.classList.add(CSSClass);
  }
};

const dTTagOnNotProperty = (row, data, property, CSSClass) => {
  /**
   * Apply CSS class to items that don't have the property defined as parameter.
   */
  const hasProperty = Object.prototype.hasOwnProperty.call(data, property);
  if (hasProperty && !data[property]) {
    row.classList.add(CSSClass);
  }
};

export const dTRowCallback = (row, data) => {
  if (data.consultation_id && data.is_draft && dTIsTemporaryDraft(data.consultation_id)) {
    row.classList.add('consultationDraft_temporary');
  }
  dTNewConsultation(row, data);
  dTTagOnNotProperty(row, data, 'active', 'warning');
  dTTagOnProperty(row, data, 'deceased', 'inactive');
  dTTagOnNotProperty(row, data, 'is_available', 'warning');
  dTTagOnProperty(row, data, 'is_draft', 'inactive');
  dTTagOnProperty(row, data, 'test_patient', 'success');
  dTTagOnProperty(row, data, 'unread', 'strong');
};

export const renderers = {
  dTAge,
  dTBoolToFile,
  dTBoolToUnread,
  dTCaseNotesIcon,
  dTColorCode,
  dTDeleteIcon,
  dTDownloadIcon,
  dTDownloadPDFIcon,
  dTEllipsis15,
  dTEllipsis30,
  dTEllipsis100,
  dTExamsToIcons,
  dTList,
  dTModalIcon,
  dTNewTabIcon,
  dTReminderAdd,
  dTReminderIcon,
  dTReportFinished,
  dTSpecialistNotesIcon,
  dTStatus,
  dTUrgencyToColor,
};
